module.exports = __webpack_public_path__ + "static/media/maple-forest-Master-DeedBy-Laws.bfbb0367.pdf";